/* Navbar scroll */
const nav = document.getElementById('navbar');
if (nav) {
  const hasHero = !!document.querySelector('.hero');
  if (!hasHero) nav.classList.add('scrolled');
  window.addEventListener('scroll', () => {
    if (hasHero) nav.classList.toggle('scrolled', window.scrollY > 10);
  }, { passive: true });
}

/* Reveal on scroll */
const revealEls = document.querySelectorAll('.reveal, .reveal-up');
if (revealEls.length) {
  const io = new IntersectionObserver((entries) => {
    entries.forEach(e => { if (e.isIntersecting) { e.target.classList.add('vis'); io.unobserve(e.target); } });
  }, { threshold: 0.1, rootMargin: '0px 0px -50px 0px' });
  revealEls.forEach(el => io.observe(el));
}

/* Hero parallax */
const heroContent = document.querySelector('.hero-content');
if (heroContent) {
  const heroH = document.querySelector('.hero')?.offsetHeight || 0;
  window.addEventListener('scroll', () => {
    const y = window.scrollY;
    if (y < heroH) {
      heroContent.style.transform = `translateY(${y * 0.28}px)`;
      heroContent.style.opacity = 1 - (y / heroH) * 1.4;
    }
  }, { passive: true });
}

/* Smooth anchor scroll */
document.querySelectorAll('a[href^="#"]').forEach(a => {
  a.addEventListener('click', e => {
    const t = document.querySelector(a.getAttribute('href'));
    if (t) { e.preventDefault(); t.scrollIntoView({ behavior: 'smooth' }); }
  });
});

/* Nosotros link — scroll to Instafeed */
document.querySelectorAll('a[href*="#nosotros"]').forEach(a => {
  a.addEventListener('click', e => {
    const selectors = ['#nosotros','[id*="instafeed"]','[class*="instafeed"]','.if-grid','[data-section-type="apps"]'];
    let target = null;
    for (const sel of selectors) { target = document.querySelector(sel); if (target) break; }
    if (target) { e.preventDefault(); window.scrollTo({ top: target.offsetTop - 100, behavior: 'smooth' }); }
  });
});
